import React from 'react'

if (process.env.NODE_ENV === 'development') {
   
  //const whyDidYouRender = require('@welldone-software/why-did-you-render')
  // @ts-ignore
  //(React, {
  //  trackAllPureComponents: true,
  //  trackHooks: true,
  // trackExtraHooks: [[useSupabaseTable, 'useSupabaseTable']]
  //})
}
